export default __webpack_public_path__ + "static/media/woman-draw-4period.a662fd7b.svg";